import Main from "../views/Main";
import yidongImg from "../assets/menu-img/yidongduan.png";
import chargeImg from "../assets/menu-img/charge.png";
import custImg from "../assets/menu-img/cust.png";
import orderImg from "../assets/menu-img/order.png";
import szImg from "@/assets/nav_slices/gs.png";
import szAImg from "@/assets/nav_slices/gs-blue.png";
import gxImg from "@/assets/nav_slices/gx.png";
import zfImg from "@/assets/nav_slices/zf.png";
import zfAImg from "@/assets/nav_slices/zf-blue.png";
import cdzImg from "@/assets/nav_slices/cdz.png";
import cdzAImg from "@/assets/nav_slices/zdz-blue.png";
import userImg from "@/assets/nav_slices/user.png";
import userAImg from "@/assets/nav_slices/user-blue.png";
import roleImg from "@/assets/nav_slices/role.png";
import roleAImg from "@/assets/nav_slices/role-blue.png";
import companyImg from "@/assets/nav_slices/company.png";
import companyAImg from "@/assets/nav_slices/company-blue.png";
import adminImg from "@/assets/nav_slices/admin.png";
import adminAImg from "@/assets/nav_slices/admin-blue.png";
import serverImg from "@/assets/nav_slices/server.png";
import serverAImg from "@/assets/nav_slices/server-blue.png";
import carImg from "@/assets/nav_slices/car.png";
import carAImg from "@/assets/nav_slices/car-blue.png";
import pileImg from "@/assets/nav_slices/pile.png";
import pileAImg from "@/assets/nav_slices/pile-blue.png";
import fankuiImg from "../assets/menu-img/fankui.png";
import settingImg from "../assets/menu-img/setting.png";
import operationalData from "../assets/menu-img/数据.png";

import emptyView from "../components/menu/empty-view.vue";

let menuRouter = [];
/**
  菜单路由
  wk 2019-11-29
*/
menuRouter = [
  // {
  //     path: "/mobileManage",
  //     meta: {
  //         title: "移动端管理",
  //         type: "hasChild",
  //         //icon:'http://img.cdn.wxzhida.cn//zdj4/menu/yidongduan.png',
  //         icon: yidongImg,
  //     },
  //     name: "mobileManage",
  //     component: Main,
  //     children: [
  //         // {    取消当前本版本使用
  //         //     path: "/noticeList",
  //         //     name: "noticeList",
  //         //     meta: {
  //         //         parent: ["mobileManage"],
  //         //         current: ["noticeList"],
  //         //         title: "通知管理",
  //         //     },
  //         //     component: (resolve) => {
  //         //         require(["../views/mobile-manage/notice/list.vue"], resolve);
  //         //     },
  //         // },
  //         // {
  //         //     path: "/openScreenList",
  //         //     name: "openScreenList",
  //         //     meta: {
  //         //         parent: ["mobileManage"],
  //         //         current: ["openScreenList"],
  //         //         title: "开屏管理",
  //         //     },
  //         //     component: (resolve) => {
  //         //         require(["../views/mobile-manage/open-screen/list.vue"], resolve);
  //         //     },
  //         // },
  //         {
  //             path: "/bannerList",
  //             name: "bannerList",
  //             meta: {
  //                 parent: ["mobileManage"],
  //                 current: ["bannerList"],
  //                 title: "banner管理",
  //             },
  //             component: (resolve) => {
  //                 require(["../views/mobile-manage/banner/list.vue"], resolve);
  //             },
  //         },
  //         {
  //             path: "/messageList",
  //             name: "messageList",
  //             meta: {
  //                 parent: ["mobileManage"],
  //                 current: ["messageList"],
  //                 title: "消息设置",
  //             },
  //             component: (resolve) => {
  //                 require(["../views/mobile-manage/message/index.vue"], resolve);
  //             },
  //         },
  //         {
  //             path: "/carsManage",
  //             name: "carsManage",
  //             meta: {
  //                 parent: ["mobileManage"],
  //                 current: ["carsManage"],
  //                 title: "车辆型号管理",
  //             },
  //             component: (resolve) => {
  //                 require(["../views/mobile-manage/car/index.vue"], resolve);
  //             },
  //         },
  //     ],
  // },

  // {
  //     path: "/chargeManage",
  //     meta: {
  //         title: "充电管理",
  //         type: "hasChild",
  //         //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/charge.png'
  //         icon: chargeImg,
  //     },
  //     name: "chargeManage",
  //     component: Main,
  //     children: [
  //         // {
  //         //     path: "/pileList",
  //         //     name: "pileList",
  //         //     meta: {
  //         //         parent: ["chargeManage"],
  //         //         current: ["pileList"],
  //         //         title: "充电桩管理",
  //         //     },
  //         //     component: (resolve) => {
  //         //         require(["../views/charging-manage/pile/list.vue"], resolve);
  //         //     },
  //         // },
  //         {
  //             path: "/pileModelList",
  //             name: "pileModelList",
  //             meta: {
  //                 parent: ["chargeManage"],
  //                 current: ["pileModelList"],
  //                 title: "充电桩型号管理",
  //             },
  //             component: (resolve) => {
  //                 require(["../views/charging-manage/pile-model/list.vue"], resolve);
  //             },
  //         },
  //     ],
  // },
  {
    path: "/userDataManage",
    meta: {
      title: "用户信息管理",
      type: "hasChild",
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/charge.png'
      // icon: custImg,
    },
    name: "userDataManage",
    component: Main,
    children: [
      {
        path: "/custList",
        name: "custList",
        meta: {
          parent: ["userDataManage"],
          current: ["custList"],
          title: "用户信息列表",
          icon: szImg,
          activeIcon: szAImg,
        },
        component: (resolve) => {
          require(["../views/userData-manage/cust-manage/list.vue"], resolve);
        },
      },
      {
        path: "/mayiGreenEnergy",
        name: "mayiGreenEnergy",
        meta: {
          type: "hasChild",
          title: "蚂蚁能量",
          icon: szImg,
        },
        component: emptyView,
        children: [
          {
            path: "/obtainRecords",
            name: "obtainRecords",
            meta: {
              parent: ["userDataManage", "mayiGreenEnergy"],
              current: ["obtainRecords"],
              title: "能量更变列表",
            },
            component: (resolve) => {
              require([
                "@/views/mayi-greenEnergy/green-energy/list.vue",
              ], resolve);
            },
          },
          {
            path: "/rechargeRecord",
            name: "rechargeRecord",
            meta: {
              parent: ["userDataManage", "mayiGreenEnergy"],
              current: ["rechargeRecord"],
              title: "订单发放列表",
            },
            component: (resolve) => {
              require([
                "@/views/mayi-greenEnergy/recharge-record/list.vue",
              ], resolve);
            },
          },
        ],
      },
    ],
  },

  {
    path: "/pileManage",
    meta: {
      title: "充电设备管理",
      type: "hasChild", // 单个的一级菜单
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/cust.png'
      // icon: custImg,
    },
    name: "pileManage",
    component: Main,
    children: [
      {
        path: "/pileList",
        name: "pileList",
        meta: {
          parent: ["pileManage"],
          current: ["pileList"],
          title: "充电桩设备列表",
          icon: cdzImg,
          activeIcon: cdzAImg,
        },
        component: (resolve) => {
          require(["../views/userData-manage/pile-manage/list.vue"], resolve);
        },
      },
      {
        path: "/sharedSwitch",
        name: "sharedSwitch",
        meta: {
          parent: ["pileManage"],
          current: ["sharedSwitch"],
          title: "共享开关设备列表",
          icon: cdzImg,
          activeIcon: cdzAImg,
        },
        component: (resolve) => {
          require(["../views/userData-manage/share-switch/list.vue"], resolve);
        },
      },
    ],
  },
  {
    path: "/chargeOrderManage",
    meta: {
      title: "订单管理",
      type: "hasChild", // 单个的一级菜单
      // icon:'http://img.cdn.wxzhida.cn/zdj4/menu/cust.png'
      // icon: custImg,
    },
    name: "chargeOrderManage",
    component: Main,
    children: [

      {
        path: "/privateChargeData",
        name: "privateChargeData",
        meta: {
          type: "hasChild",
          title: "私桩充电订单",
          icon: szImg,
        },
        component: emptyView,
        children: [
          {
            path: "/normalList",
            name: "normalList",
            meta: {
              parent: ["chargeOrderManage", "privateChargeData"],
              current: ["normalList"],
              title: "正常充电订单",
            },
            component: (resolve) => {
              require([
                "@/views/charging-manage/pile-charge/private-charge-data/list.vue",
              ], resolve);
            },
          },
          {
            path: "/unusualList",
            name: "unusualList",
            meta: {
              parent: ["chargeOrderManage", "privateChargeData"],
              current: ["unusualList"],
              title: "异常充电订单",
            },
            component: (resolve) => {
              require([
                "@/views/charging-manage/pile-charge/private-charge-data/list.vue",
              ], resolve);
            },
          },
        ],
      },
      {
        path: "/publicChargeData",
        name: "publicChargeData",
        meta: {
          type: "hasChild",
          title: "共享充电订单",
          icon: gxImg,
        },
        component: emptyView,
        children: [
          {
            path: "/publicNormalList",
            name: "publicNormalList",
            meta: {
              parent: ["chargeOrderManage", "publicChargeData"],
              current: ["publicNormalList"],
              title: "共享充电正常订单",
            },
            component: (resolve) => {
              require([
                "@/views/charging-manage/pile-charge/public-charge-data/list.vue",
              ], resolve);
            },
          },
          {
            path: "/publicUnusualList",
            name: "publicUnusualList",
            meta: {
              parent: ["chargeOrderManage", "publicChargeData"],
              current: ["publicUnusualList"],
              title: "共享充电异常订单",
            },
            component: (resolve) => {
              require([
                "@/views/charging-manage/pile-charge/public-charge-data/list.vue",
              ], resolve);
            },
          },
        ],
      },
      {
        path: '/personalSattion',
        name: 'personalSattion',
        meta: {
          type: 'hasChild',
          title: '个人站共享订单',
          icon: gxImg
        },
        component: emptyView,
        children: [
          {
            path: "/sharedChargingOrders",
            name: "sharedChargingOrders",
            meta: {
              parent: ["chargeOrderManage", "personalSattion"],
              current: ["sharedChargingOrders"],
              title: "共享充电订单",
            },
            component: (resolve) => {
              require([
                "@/views/charging-manage/personal-station/shared-charging-order/list.vue",
              ], resolve);
            },
          },
          {
            path: "/sharedBookingOrders",
            name: "sharedBookingOrders",
            meta: {
              parent: ["chargeOrderManage", "personalSattion"],
              current: ["sharedBookingOrders"],
              title: "共享预约订单",
            },
            component: (resolve) => {
              require([
                "@/views/charging-manage/personal-station/shared-booking-order/list.vue",
              ], resolve);
            },
          },
        ]
      },
      {
        path: "/purchaseOrderList",
        name: "purchaseOrderList",
        meta: {
          parent: ["chargeOrderManage"],
          current: ["purchaseOrderList"],
          title: "支付订单列表",
          icon: zfImg,
          activeIcon: zfAImg,
        },
        component: (resolve) => {
          require([
            "@/views/charging-manage/pile-charge/purchase-order-data/list.vue",
          ], resolve);
        },
      },
      {
        path: "/zeroPayOrderList",
        name: "zeroPayOrderList",
        meta: {
          parent: ["chargeOrderManage"],
          current: ["zeroPayOrderList"],
          title: "家充无忧服务订单",
          icon: zfImg,
          activeIcon: zfAImg,
        },
        component: (resolve) => {
          require([
            "@/views/charging-manage/pile-charge/zero-pay-order/list.vue",
          ], resolve);
        },
      },
      // 活动订单列表
      {
        path: "/activityOrderZreo",
        name: "activityOrderZreo",
        meta: {
          type: "hasChild",
          title: "活动订单列表",
          icon: zfImg,
          activeIcon: zfAImg,
        },
        component: emptyView,
        children: [
          //   {
          //   path: "/activityOrderZreoPay",
          //   name: "activityOrderZreoPay",
          //   meta: {
          //     parent: ["chargeOrderManage", "activityOrderZreo"],
          //     current: ["activityOrderZreoPay"],
          //     title: "家充无忧服务活动报表",
          //   },
          //   component: (resolve) => {
          //     require([
          //       "@/views/cust-pile-plan/pile-cust-activity/index.vue",
          //     ], resolve);
          //   },
          // },
          {
            path: "/activityOrderZreoList",
            name: "activityOrderZreoList",
            meta: {
              parent: ["chargeOrderManage", "activityOrderZreo"],
              current: ["activityOrderZreoList"],
              title: "家充无忧服务订单列表",
              type: "hasChild",
            },
            component: (resolve) => {
              require([
                "@/views/cust-pile-plan/activity-order-list/list.vue",
              ], resolve);
            },

            // 老的 499 活动 相关 - 弃用
            // component: (resolve) => {
            //   require([
            //     "@/views/activity-manage/activity-order-list/list.vue",
            //   ], resolve)},
          },
          {
            path: "/refundTotalOrderList",
            name: "refundTotalOrderList",
            meta: {
              parent: ["chargeOrderManage", "activityOrderZreo"],
              current: ["refundTotalOrderList"],
              title: "总退款订单列表",
            },
            component: (resolve) => {
              require([
                "@/views/cust-pile-plan/refund-total-order/index.vue",
              ], resolve);
            },
          },
          {
            path: "/serviceTotalOrderList",
            name: "serviceTotalOrderList",
            meta: {
              parent: ["chargeOrderManage", "activityOrderZreo"],
              current: ["serviceTotalOrderList"],
              title: "总服务账单列表",
            },
            component: (resolve) => {
              require([
                "@/views/cust-pile-plan/service-total-order/index.vue",
              ], resolve);
            },
          },
          {
            path: "/wareTotalOrderList",
            name: "wareTotalOrderList",
            meta: {
              parent: ["chargeOrderManage", "activityOrderZreo"],
              current: ["wareTotalOrderList"],
              title: "总商品订单列表",
            },
            component: (resolve) => {
              require([
                "@/views/cust-pile-plan/ware-total-order/index.vue",
              ], resolve);
            },
          },
          {
            path: "/entryUserOrderList",
            name: "entryUserOrderList",
            meta: {
              parent: ["chargeOrderManage", "activityOrderZreo"],
              current: ["entryUserOrderList"],
              title: "报名用户订单列表",
            },
            component: (resolve) => {
              require([
                "@/views/cust-pile-plan/entry-user-order/index.vue",
              ], resolve);
            },
          },
          {
            path: "/activityDiscountList",
            name: "activityDiscountList",
            meta: {
              parent: ["chargeOrderManage", "activityOrderZreo"],
              current: ["activityDiscountList"],
              title: "活动折扣券列表",
            },
            component: (resolve) => {
              require([
                "@/views/cust-pile-plan/activity-discount-list/list.vue",
              ], resolve);
            },
          },
        ],
      },
      // 活动报表 新增
      {
        path: "/reportFormsByZero",
        name: "reportFormsByZero",
        meta: {
          type: "hasChild",
          title: "家充无忧报表",
          icon: zfImg,
          activeIcon: zfAImg,
        },
        component: emptyView,
        children: [
          {
            path: "/activityOrderZreoPay",
            name: "activityOrderZreoPay",
            meta: {
              parent: ["chargeOrderManage", "reportFormsByZero"],
              current: ["activityOrderZreoPay"],
              title: "家充无忧服务活动报表",
            },
            component: (resolve) => {
              require([
                "@/views/cust-pile-plan/pile-cust-activity/index.vue",
              ], resolve);
            },
          },
          // {
          //   path: "/notSignReportList",
          //   name: "notSignReportList",
          //   meta: {
          //     parent: ["chargeOrderManage", "reportFormsByZero"],
          //     current: ["notSignReportList"],
          //     title: "不签约/不安装订单列表",
          //   },
          //   component: (resolve) => {
          //     require([
          //       "@/views/cust-pile-plan/notSign-reportList/index.vue",
          //     ], resolve);
          //   },
          // },
          // {
          //   path: "/hasComplatedReportList",
          //   name: "hasComplatedReportList",
          //   meta: {
          //     parent: ["chargeOrderManage", "reportFormsByZero"],
          //     current: ["hasComplatedReportList"],
          //     title: "已完成安装订单列表",
          //   },
          //   component: (resolve) => {
          //     require([
          //       "@/views/cust-pile-plan/hasComplated-reportList/index.vue",
          //     ], resolve);
          //   },
          // },
          // {
          //   path: "/userChargeReportList",
          //   name: "userChargeReportList",
          //   meta: {
          //     parent: ["chargeOrderManage", "reportFormsByZero"],
          //     current: ["userChargeReportList"],
          //     title: "用户充电订单列表",
          //   },
          //   component: (resolve) => {
          //     require([
          //       "@/views/cust-pile-plan/userCharge-reportList/index.vue",
          //     ], resolve);
          //   },
          // },
          // {
          //   path: "/channelBindReportList",
          //   name: "channelBindReportList",
          //   meta: {
          //     parent: ["chargeOrderManage", "reportFormsByZero"],
          //     current: ["channelBindReportList"],
          //     title: "各渠道已绑桩用户列表",
          //   },
          //   component: (resolve) => {
          //     require([
          //       "@/views/cust-pile-plan/channelBind-reportList/index.vue",
          //     ], resolve);
          //   },
          // },
          // {
          //   path: "/channelProportionReportList",
          //   name: "channelProportionReportList",
          //   meta: {
          //     parent: ["chargeOrderManage", "reportFormsByZero"],
          //     current: ["channelProportionReportList"],
          //     title: "各渠道已绑桩用户占比",
          //   },
          //   component: (resolve) => {
          //     require([
          //       "@/views/cust-pile-plan/channelProportion-reportList/index.vue",
          //     ], resolve);
          //   },
          // },
        ],
      },
      {
        path: "/packageList",
        name: "packageList",
        meta: {
          parent: ["chargeOrderManage"],
          current: ["packageList"],
          title: "家充无忧服务配置",
          icon: zfImg,
          activeIcon: zfAImg,
        },
        component: (resolve) => {
          require(["@/views/cust-pile-plan/package-list/index.vue"], resolve);
        },
      },
      {
        path: "/couponList",
        name: "couponList",
        meta: {
          parent: ["chargeOrderManage"],
          current: ["couponList"],
          title: "优惠券发放列表",
          icon: zfImg,
          activeIcon: zfAImg,
        },
        component: (resolve) => {
          require(["@/views/activity-manage/coupon-list/list.vue"], resolve);
        },
      },
      {
        path: "/familyChargingProductOrder",
        name: "familyChargingProductOrder",
        meta: {
          parent: ["chargeOrderManage"],
          current: ["familyChargingProductOrder"],
          title: "家庭充电商品订单",
          icon: zfImg,
          activeIcon: zfAImg,
        },
        component: (resolve) => {
          require(["@/views/charging-manage/family-charging-product-order/list.vue"], resolve);
        },
      },
      {
        path: "/familyChargingServiceActivity",
        name: "familyChargingServiceActivity",
        meta: {
          parent: ["chargeOrderManage"],
          current: ["familyChargingServiceActivity"],
          title: "家庭充电服务活动列表",
          icon: zfImg,
          activeIcon: zfAImg,
        },
        component: (resolve) => {
          require(["@/views/charging-manage/family-charging-service-activity/list.vue"], resolve);
        },
      },
    ],
  },

  // {
  //     path: "/custManage",
  //     meta: {
  //         title: "客户管理",
  //         type: "noChild", // 单个的一级菜单
  //         //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/cust.png'
  //         icon: custImg,
  //     },
  //     name: "custManage",
  //     component: Main,
  //     children: [{
  //         path: "/custManageList",
  //         name: "custManageList",
  //         meta: {
  //             parent: ["custManage"],
  //             current: ["custManageList"],
  //             title: "客户管理",
  //         },
  //         component: (resolve) => {
  //             require(["../views/cust-manage/list.vue"], resolve);
  //         },
  //     }, ],
  // },
  // {
  //     path: "/orderManage",
  //     meta: {
  //         title: "订单管理",
  //         type: "hasChild",
  //         //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/order.png'
  //         icon: orderImg,
  //     },
  //     name: "orderManage",
  //     component: Main,
  //     children: [
  //         {
  //             path: "/orderManageList",
  //             name: "orderManageList",
  //             meta: {
  //                 parent: ["orderManage"],
  //                 current: ["orderManageList"],
  //                 title: "充电订单管理",
  //             },
  //             component: (resolve) => {
  //                 require(["../views/order-manage/order-pile-manage/list.vue"], resolve);
  //             },
  //         },
  //         {
  //             path: "/payOrderList",
  //             name: "payOrderList",
  //             meta: {
  //                 parent: ["orderManage"],
  //                 current: ["payOrderList"],
  //                 title: "支付订单管理",
  //             },
  //             component: (resolve) => {
  //                 require(["../views/order-manage/order-pile-paying/index.vue"], resolve);
  //             },
  //         }
  //     ],
  // },
  // {   取消当前本版本使用
  //     path: "/serviceFeedback",
  //     meta: {
  //         title: "服务和反馈",
  //         type: "hasChild",
  //         //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/fankui.png'
  //         icon: fankuiImg,
  //     },
  //     name: "serviceFeedback",
  //     component: Main,
  //     children: [{
  //         path: "/feedbackRouter",
  //         name: "feedbackRouter",
  //         meta: {
  //             parent: ["serviceFeedback"],
  //             current: ["feedbackRouter"],
  //             title: "去腾讯吐个槽",
  //         },
  //         component: (resolve) => {
  //             require(["../views/service-feedback/index.vue"], resolve);
  //         },
  //     },
  //     {
  //         path: "/serviceRecordList",
  //         name: "serviceRecordList",
  //         meta: {
  //             parent: ["serviceFeedback"],
  //             current: ["serviceRecordList"],
  //             title: "服务记录",
  //         },
  //         component: (resolve) => {
  //             require(["../views/service-record/list.vue"], resolve);
  //         },
  //     }, ],
  // },

  {
    path: "/systemManage",
    meta: {
      title: "基础信息管理",
      type: "hasChild",
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/setting.png'
      // icon: settingImg,
    },
    name: "systemManage",
    component: Main,
    children: [
      // {
      //     path: "/message",
      //     name: "message",
      //     meta: {
      //         parent: ["systemManage"],
      //         current: ["message"],
      //         title: "消息管理",
      //     },
      //     component: (resolve) => {
      //         require(["../views/basicData-manage/message/list.vue"], resolve);
      //     },
      // },
      {
        path: "/userManageList",
        name: "user_list",
        meta: {
          parent: ["systemManage"],
          current: ["user_list"],
          title: "用户管理",
          icon: userImg,
          activeIcon: userAImg,
        },
        component: (resolve) => {
          require(["../views/basicData-manage/user-manage/list.vue"], resolve);
        },
      },
      {
        path: "/roleManageList",
        name: "role_list",
        meta: {
          parent: ["systemManage"],
          current: ["role_list"],
          title: "角色管理",
          icon: roleImg,
          activeIcon: roleAImg,
        },
        component: (resolve) => {
          require(["../views/basicData-manage/role-manage/list.vue"], resolve);
        },
      },
      {
        path: "/VehicleManagement",
        name: "VehicleManagement",
        meta: {
          type: "hasChild",
          title: "车辆基础信息管理",
          icon: carImg,
          activeIcon: carAImg,
        },
        component: emptyView,
        children: [
          {
            path: "/brandList",
            name: "brandList",
            meta: {
              parent: ["systemManage", "VehicleManagement"],
              current: ["brandList"],
              title: "车辆品牌管理",
            },
            component: (resolve) => {
              require([
                "../views/basicData-manage/VehicleManagement/VehicleBrand/list.vue",
              ], resolve);
            },
          },
          {
            path: "/modelList",
            name: "modelList",
            meta: {
              parent: ["systemManage", "VehicleManagement"],
              current: ["modelList"],
              title: "车辆型号管理",
            },
            component: (resolve) => {
              require([
                "../views/basicData-manage/VehicleManagement/VehicleModel/list.vue",
              ], resolve);
            },
          },
        ],
      },
      {
        path: "/ChargingPile",
        name: "ChargingPile",
        meta: {
          parent: ["systemManage"],
          current: ["ChargingPile"],
          title: "充电桩基础信息管理",
          icon: pileImg,
          activeIcon: pileAImg,
        },
        component: (resolve) => {
          require(["../views/basicData-manage/ChargingPile/list.vue"], resolve);
        },
      },
      {
        path: "/IntegralParameter",
        name: "IntegralParameter",
        meta: {
          parent: ["systemManage"],
          current: ["IntegralParameter"],
          title: "积分参数配置",
          icon: pileImg,
          activeIcon: pileAImg,
        },
        component: (resolve) => {
          require([
            "../views/basicData-manage/IntegralParameter/list.vue",
          ], resolve);
        },
      },
    ],
  },
  {
    path: "/SupertubeDataManage",
    meta: {
      title: "基础信息配置",
      type: "hasChild",
      //icon:'http://img.cdn.wxzhida.cn/zdj4/menu/setting.png'
      // icon: settingImg,
    },
    name: "SupertubeDataManage",
    component: Main,
    children: [
      {
        path: "/companyManageList",
        name: "company_list",
        meta: {
          parent: ["SupertubeDataManage"],
          current: ["company_list"],
          title: "公司信息管理",
          icon: companyImg,
          activeIcon: companyAImg,
        },
        component: (resolve) => {
          require(["../views/supertube-data/company-manage/list.vue"], resolve);
        },
      },
      {
        path: "/companySysManage",
        name: "companySysManage",
        meta: {
          parent: ["SupertubeDataManage"],
          current: ["companySysManage"],
          title: "公司系统管理员配置",
          icon: adminImg,
          activeIcon: adminAImg,
        },
        component: (resolve) => {
          require(["../views/supertube-data/com-sys-manage/list.vue"], resolve);
        },
      },
      {
        path: "/serverManage",
        name: "serverManage",
        meta: {
          parent: ["SupertubeDataManage"],
          current: ["serverManage"],
          title: "服务器配置",
          icon: serverImg,
          activeIcon: serverAImg,
        },
        component: (resolve) => {
          require(["../views/supertube-data/server-manage/list.vue"], resolve);
        },
      },
      // {
      //     path: "/roleManageList",
      //     name: "role_list",
      //     meta: {
      //         parent: ["SupertubeDataManage"],
      //         current: ["role_list"],
      //         title: "角色管理",
      //         icon:roleImg,
      //         activeIcon:roleAImg
      //     },
      //     component: (resolve) => {
      //         require(["../views/basicData-manage/role-manage/list.vue"], resolve);
      //     },
      // },
    ],
  },
  {
    path: "/deviceManage",
    meta: {
      title: "设备升级",
      type: "hasChild",
      //    icon: updateImg,
    },
    name: "deviceManage",
    component: Main,
    children: [
      {
        path: "/UpgradeManagement",
        name: "UpgradeManagement",
        meta: {
          parent: ["deviceManage"],
          current: ["UpgradeManagement"],
          title: "升级管理",
        },
        component: (resolve) => {
          require([
            "../views/Device-manage/UpgradeManagement/list.vue",
          ], resolve);
        },
      },
      {
        path: "/versionManagement",
        name: "versionManagement",
        meta: {
          parent: ["deviceManage"],
          current: ["versionManagement"],
          title: "版本管理",
        },
        component: (resolve) => {
          require([
            "../views/Device-manage/versionManagement/index.vue",
          ], resolve);
        },
      },
      {
        path: "/appVersion",
        name: "appVersion",
        meta: {
          parent: ["deviceManage"],
          current: ["appVersion"],
          title: "APP版本管理",
        },
        component: (resolve) => {
          require(["../views/Device-manage/appVersion/list.vue"], resolve);
        },
      },
    ],
  },

  {
    path: "/operationsAnalysis",
    meta: {
      title: "运营分析",
      type: "hasChild",
      //    icon: updateImg,
    },
    name: "operationsAnalysis",
    component: Main,
    children: [
      {
        path: "/operationalData",
        name: "operationalData",
        meta: {
          parent: ["operationsAnalysis"],
          current: ["operationalData"],
          title: "运营数据概览",
          // activeIcon: operationalData,
        },
        component: (resolve) => {
          require([
            "../views/operationsAnalysis-mange/operationalData/list.vue",
          ], resolve);
        },
      },

      {
        path: "/userDataInformation",
        name: "userDataInformation",
        meta: {
          type: "hasChild",
          title: "用户数据信息",
          // icon: carImg,
          // activeIcon: carAImg,
        },
        component: emptyView,
        children: [
          {
            path: "/userRegistrationReport",
            name: "userRegistrationReport",
            meta: {
              parent: ["operationsAnalysis", "userDataInformation"],
              current: ["userRegistrationReport"],
              title: "用户注册报表",
            },
            component: (resolve) => {
              require([
                "../views/operationsAnalysis-mange/userDataInformation/userRegistrationReport/list.vue",
              ], resolve);
            },
          },
          {
            path: "/ActiveUserReport",
            name: "ActiveUserReport",
            meta: {
              parent: ["operationsAnalysis", "userDataInformation"],
              current: ["ActiveUserReport"],
              title: "活跃用户报表",
            },
            component: (resolve) => {
              require([
                "../views/operationsAnalysis-mange/userDataInformation/ActiveUserReport/list.vue",
              ], resolve);
            },
          },
          {
            path: "/improvementList",
            name: "improvementList",
            meta: {
              parent: ["operationsAnalysis", "userDataInformation"],
              current: ["improvementList"],
              title: "用户信息完善列表",
            },
            component: (resolve) => {
              require([
                "../views/operationsAnalysis-mange/userDataInformation/improvementList/list.vue",
              ], resolve);
            },
          },
          {
            path: "/UserChargingReport",
            name: "UserChargingReport",
            meta: {
              parent: ["operationsAnalysis", "userDataInformation"],
              current: ["UserChargingReport"],
              title: "用户充电习惯报表",
            },
            component: (resolve) => {
              require([
                "../views/operationsAnalysis-mange/userDataInformation/UserChargingReport/list.vue",
              ], resolve);
            },
          },
          {
            path: "/privatePilereport",
            name: "privatePilereport",
            meta: {
              parent: ["operationsAnalysis", "userDataInformation"],
              current: ["privatePilereport"],
              title: "私桩共享设置报表",
            },
            component: (resolve) => {
              require([
                "../views/operationsAnalysis-mange/userDataInformation/privatePilereport/list.vue",
              ], resolve);
            },
          },
        ],
      },
      {
        path: "/stationBindingInfo",
        name: "stationBindingInfo",
        meta: {
          type: "hasChild",
          title: "充电桩绑定信息",
          // icon: carImg,
          // activeIcon: carAImg,
        },
        component: emptyView,
        children: [
          {
            path: "/stationBindingReport",
            name: "stationBindingReport",
            meta: {
              parent: ["operationsAnalysis", "stationBindingInfo"],
              current: ["stationBindingReport"],
              title: "充电桩绑定报表",
            },
            component: (resolve) => {
              require([
                "../views/operationsAnalysis-mange/stationBindingInfo/list.vue",
              ], resolve);
            },
          },
        ],
      },
      {
        path: "/chargingOrderInfo",
        name: "chargingOrderInfo",
        meta: {
          type: "hasChild",
          title: "充电订单信息",
          // icon: carImg,
          // activeIcon: carAImg,
        },
        component: emptyView,
        children: [
          {
            path: "/OrderTypeReport",
            name: "OrderTypeReport",
            meta: {
              parent: ["operationsAnalysis", "chargingOrderInfo"],
              current: ["OrderTypeReport"],
              title: "充电订单类型报表",
            },
            component: (resolve) => {
              require([
                "../views/operationsAnalysis-mange/chargingOrderInfo/list.vue",
              ], resolve);
            },
          },
        ],
      },
      {
        path: "/advertisingInformation",
        name: "advertisingInformation",
        meta: {
          type: "hasChild",
          title: "广告位运营信息",
          // icon: carImg,
          // activeIcon: carAImg,
        },
        component: emptyView,
        children: [
          {
            path: "/clickReport",
            name: "clickReport",
            meta: {
              parent: ["operationsAnalysis", "advertisingInformation"],
              current: ["clickReport"],
              title: "广告位点击报表",
            },
            component: (resolve) => {
              require([
                "../views/operationsAnalysis-mange/advertisingInformation/clickReport/list.vue",
              ], resolve);
            },
          },
          {
            path: "/bulletinBoard",
            name: "bulletinBoard",
            meta: {
              parent: ["operationsAnalysis", "advertisingInformation"],
              current: ["bulletinBoard"],
              title: "公告栏点击报表",
            },
            component: (resolve) => {
              require([
                "../views/operationsAnalysis-mange/advertisingInformation/bulletinBoard/list.vue",
              ], resolve);
            },
          },
        ],
      },
    ],
  },
  {
    path: "/operationConfiguration",
    meta: {
      title: "运营配置",
      type: "hasChild",
      //    icon: updateImg,
    },
    name: "operationConfiguration",
    component: Main,
    children: [
      // {
      //   path: "/couponManagement",
      //   name: "couponManagement",
      //   meta: {
      //     parent: ["deviceManage"],
      //     current: ["couponManagement"],
      //     title: "优惠券配置",
      //     activeIcon: operationalData,
      //   },
      //   component: (resolve) => {
      //     require([
      //       "../views/operationConfiguration/advertisingSpaceManagement/advertisingSpaceConfiguration/list.vue",
      //     ], resolve);
      //   },
      // },
      {
        path: "/couponManagement",
        name: "couponManagement",
        meta: {
          parent: ["operationConfiguration"],
          current: ["couponManagement"],
          title: "优惠券管理",
          type: "hasChild",
          // activeIcon: operationalData,
        },
        component: emptyView,
        children: [
          {
            path: "/couponAllocation",
            name: "couponAllocation",

            meta: {
              parent: ["operationConfiguration", "couponManagement"],
              current: ["couponAllocation"],
              title: "优惠券配置",
            },
            component: (resolve) => {
              require([
                "../views/operationConfiguration/couponManagement/couponAllocation/list.vue",
              ], resolve);
            },
          },
          {
            path: "/couponDistribution",
            name: "couponDistribution",
            meta: {
              parent: ["operationConfiguration", "couponManagement"],
              current: ["couponDistribution"],
              title: "优惠券发放列表",
            },
            component: (resolve) => {
              require([
                "../views/operationConfiguration/couponManagement/couponDistribution/list.vue",
              ], resolve);
            },
          },
        ],
      },
      {
        path: "/advertisingSpaceManagement",
        name: "advertisingSpaceManagement",
        meta: {
          type: "hasChild",
          title: "广告位管理",
          parent: ["operationConfiguration"],
          current: ["advertisingSpaceManagement"],
          // icon: carImg,
          // activeIcon: carAImg,
        },
        component: emptyView,
        children: [
          {
            path: "/advertisingSpaceConfiguration",
            name: "advertisingSpaceConfiguration",
            meta: {
              parent: ["operationConfiguration", "advertisingSpaceManagement"],
              current: ["advertisingSpaceConfiguration"],
              title: "广告位配置",
            },
            component: (resolve) => {
              require([
                "../views/operationConfiguration/advertisingSpaceManagement/advertisingSpaceConfiguration/list.vue",
              ], resolve);
            },
          },
          {
            path: "/announcementBoardConfiguration",
            name: "announcementBoardConfiguration",
            meta: {
              parent: ["operationConfiguration", "advertisingSpaceManagement"],
              current: ["announcementBoardConfiguration"],
              title: "公告栏配置",
            },
            component: (resolve) => {
              require([
                "../views/operationConfiguration/advertisingSpaceManagement/announcementBoardConfiguration/list.vue",
              ], resolve);
            },
          },
        ],
      },
      {
        path: "/messagePushConfiguration",
        name: "messagePushConfiguration",
        meta: {
          parent: ["operationConfiguration"],
          current: ["messagePushConfiguration"],
          title: "消息推送",
          type: "hasChild",
        },
        component: emptyView,
        children: [
          {
            path: "/messagePushConfigurationList",
            name: "messagePushConfigurationList",
            meta: {
              parent: ["operationConfiguration", "messagePushConfiguration"],
              current: ["messagePushConfigurationList"],
              title: "消息推送记录",
            },
            component: (resolve) => {
              require([
                "../views/operationConfiguration/messagePushConfiguration/messagePushConfigurationList.vue",
              ], resolve);
            },
          },
        ],
      }
    ],
  },
  {
    path: "/marketingActivity",
    name: "marketingActivity",
    meta: {
      title: "营销活动",
      type: "hasChild",
    },
    component: Main,
    children: [
      {
        path: "/axbActivity",
        name: "axbActivity",
        redirect: "/axbProductOrder",
        meta: {
          parent: ["marketingActivity"],
          current: ["axbActivity"],
          title: "安心包598活动",
          type: "hasChild",
        },
        component: emptyView,
        children: [
          {
            path: "/axbServiceList",
            name: "axbServiceList",
            meta: {
              parent: ["marketingActivity", "axbActivity"],
              current: ["axbServiceList"],
              title: "安心包活动列表",
            },
            component: (resolve) => {
              require(["../views/marketingActivity/anxinPackActivity/list.vue"], resolve);
            },
          },
          {
            path: "/axbProductOrder",
            name: "axbProductOrder",
            meta: {
              parent: ["marketingActivity", "axbActivity"],
              current: ["axbProductOrder"],
              title: "安心包商品订单",
            },
            component: (resolve) => {
              require(["../views/marketingActivity/anxinPack/list.vue"], resolve);
            },
          },
          {
            path: "/axbAgentList",
            name: "axbAgentList",
            meta: {
              parent: ["marketingActivity", "axbActivity"],
              current: ["axbAgentList"],
              title: "渠道管理",
            },
            component: (resolve) => {
              require(["../views/marketingActivity/channelManage/list.vue"], resolve);
            },
          },
          {
            path: "/axbAgentLevel2List",
            name: "axbAgentLevel2List",
            meta: {
              parent: ["marketingActivity", "axbActivity"],
              current: ["axbAgentLevel2List"],
              title: "二级渠道列表",
            },
            component: (resolve) => {
              require(["../views/marketingActivity/channelManage/level2List.vue"], resolve);
            },
          },
          {
            path: "/giftRecord",
            name: "giftRecord",
            meta: {
              parent: ["marketingActivity", "axbActivity"],
              current: ["giftRecord"],
              title: "服务费配置记录",
            },
            component: (resolve) => {
              require(["../views/marketingActivity/giftRecord/index.vue"], resolve);
            },
          },
          {
            path: "/xhsActivity",
            name: "xhsActivity",
            meta: {
              parent: ["marketingActivity", "axbActivity"],
              current: ["xhsActivity"],
              title: "698小红书分享活动记录",
            },
            component: (resolve) => {
              require(["../views/marketingActivity/xhsActivity/list.vue"], resolve);
            },
          },
        ],
      },
      // {
      //   path: "/anxinPackActivity",
      //   name: "anxinPackActivity",
      //   meta: {
      //     parent: ["marketingActivity"],
      //     current: ["anxinPackActivity"],
      //     title: "安心包活动",
      //     type: "hasChild",
      //   },
      //   component: emptyView,
      // children: [
      //   {
      //     path: "/anxinPackList",
      //     name: "anxinPackList",
      //     meta: {
      //       parent: ["marketingActivity", "anxinPackActivity"],
      //       current: ["anxinPackList"],
      //       title: "安心包活动列表",
      //     },
      //     component: (resolve) => {
      //       require(["../views/marketingActivity/anxinPack/list.vue"], resolve);
      //     },
      //   },
      // ],
      // },
      {
        path: "/emptySwitchActivity",
        name: "emptySwitchActivity",
        redirect: "/emptySwitchActivityList",
        meta: {
          parent: ["marketingActivity"],
          current: ["emptySwitchActivity"],
          title: "空开活动",
          type: "hasChild",
        },
        component: emptyView,
        children: [
          {
            path: "/emptySwitchActivityList",
            name: "emptySwitchActivityList",
            meta: {
              parent: ["marketingActivity", "emptySwitchActivity"],
              current: ["emptySwitchActivityList"],
              title: "空开活动服务列表",
            },
            component: (resolve) => {
              require([
                "../views/marketingActivity/emptySwitchActivity/emptySwitchActivityList.vue",
              ], resolve);
            },
          },
          {
            path: "/emptySwitchOrderList",
            name: "emptySwitchOrderList",
            meta: {
              parent: ["marketingActivity", "emptySwitchActivity"],
              current: ["emptySwitchOrderList"],
              title: "空开商品订单",
            },
            component: (resolve) => {
              require([
                "../views/marketingActivity/emptySwitchActivity/emptySwitchOrderList.vue",
              ], resolve);
            },
          },
          {
            path: "/emptySwitchAgentList",
            name: "emptySwitchAgentList",
            meta: {
              parent: ["marketingActivity", "emptySwitchActivity"],
              current: ["emptySwitchAgentList"],
              title: "空开代理商管理",
            },
            component: (resolve) => {
              require([
                "../views/marketingActivity/emptySwitchActivity/emptySwitchAgentList.vue",
              ], resolve);
            },
          },
          {
            path: "/emptySwitchAgentLevel2List",
            name: "emptySwitchAgentLevel2List",
            meta: {
              parent: ["marketingActivity", "emptySwitchActivity"],
              current: ["emptySwitchAgentLevel2List"],
              title: "二级代理商列表",
            },
            component: (resolve) => {
              require([
                "../views/marketingActivity/emptySwitchActivity/emptySwitchAgentLevel2List.vue",
              ], resolve);
            },
          },
        ],
      },
      {
        path: "/pileDonationActivity",
        name: "pileDonationActivity",
        redirect: "/pileDonationServiceList",
        meta: {
          parent: ["marketingActivity"],
          current: ["pileDonationActivity"],
          title: "送桩活动",
          type: "hasChild",
        },
        component: emptyView,
        children: [
          {
            path: "/pileDonationServiceList",
            name: "pileDonationServiceList",
            meta: {
              parent: ["marketingActivity", "pileDonationActivity"],
              current: ["pileDonationServiceList"],
              title: "送桩服务列表",
            },
            component: (resolve) => {
              require([
                "../views/marketingActivity/pileDonationActivity/pileDonationServiceList.vue",
              ], resolve);
            },
          },
          {
            path: "/pileDonationProductOrder",
            name: "productOrder",
            meta: {
              parent: ["marketingActivity", "pileDonationActivity"],
              current: ["productOrder"],
              title: "送桩商品订单",
            },
            component: (resolve) => {
              require([
                "../views/marketingActivity/pileDonationActivity/productOrder.vue",
              ], resolve);
            },
          },
          {
            path: "/homeChargingAgentList",
            name: "homeChargingAgentList",
            meta: {
              parent: ["marketingActivity", "pileDonationActivity"],
              current: ["homeChargingAgentList"],
              title: "送桩代理商管理",
            },
            component: (resolve) => {
              require([
                "../views/marketingActivity/pileDonationActivity/homeChargingAgentList.vue",
              ], resolve);
            },
          },
          {
            path: "/homeChargingAgentLevel2List",
            name: "homeChargingAgentLevel2List",
            meta: {
              parent: ["marketingActivity", "pileDonationActivity"],
              current: ["homeChargingAgentLevel2List"],
              title: "二级代理商列表",
            },
            component: (resolve) => {
              require([
                "../views/marketingActivity/pileDonationActivity/homeChargingAgentLevel2List.vue",
              ], resolve);
            },
          },
        ],
      },
      // 老499活动订单列表（原 activityOrderZreoList 挂载的老页面，路由曾注释弃用，现恢复展示）
      {
        path: "/old499ActivityOrderList",
        name: "old499ActivityOrderList",
        meta: {
          parent: ["marketingActivity"],
          current: ["old499ActivityOrderList"],
          title: "老499活动订单列表",
          icon: zfImg,
          activeIcon: zfAImg,
        },
        component: (resolve) => {
          require([
            "../views/activity-manage/activity-order-list/list.vue",
          ], resolve);
        },
      },
    ],
  },
  {
    path: '/personalStationReport',
    name: 'personalStationReport',
    meta: {
      title: '个人站运营管理',
      type: 'hasChild',
    },
    component: Main,
    children: [
      {
        path: "/personalOperationReport",
        name: "personalOperationReport",
        meta: {
          parent: ["personalStationReport", "chargeDeviceManage"],
          current: ["personalOperationReport"],
          title: "个人站运营报表",
        },
        component: (resolve) => {
          require([
            "@/views/personal-station-report/operation-report/index.vue",
          ], resolve);
        },
      },
      // {
      //   path: "/personalOperationBill",
      //   name: "personalOperationBill",
      //   meta: {
      //     parent: ["personalStationReport", "chargeDeviceManage"],
      //     current: ["personalOperationBill"],
      //     title: "个人运营账单",
      //   },
      //   component: (resolve) => {
      //     require([
      //       "@/views/personal-station-report/operation-bill/index.vue",
      //     ], resolve);
      //   },
      // },
      // {
      //   path: "/personalTrafficCost",
      //   name: "personalTrafficCost",
      //   meta: {
      //     parent: ["personalStationReport", "chargeDeviceManage"],
      //     current: ["personalTrafficCost"],
      //     title: "个人站流量费用管理",
      //   },
      //   component: (resolve) => {
      //     require([
      //       "@/views/personal-station-report/traffic-cost/index.vue",
      //     ], resolve);
      //   },
      // },
    ],
  }
];

export default menuRouter;
